// extracted by mini-css-extract-plugin
export default {"homologacaoBotoes":"ArquivarConsulta_homologacaoBotoes__Y6SxW","motivoArquivamento":"ArquivarConsulta_motivoArquivamento__jblqk"};